import { Button, Grid, Typography } from "@mui/material";
import TimeTabView from "./TimeTabView";
import { useTimeTab } from "./useTimeTab";

const ProductionPriorityUI = () => {
  const timeTab = useTimeTab();

  return (
    <Grid container>
      <Grid item xs={12}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            padding: "0.5rem 0",
            justifyContent: "space-between",
            alignItems: "center",
            background: "var(--header)",
            color: "#fff",
            minHeight: "6vh",
          }}
        >
          <div style={{ paddingLeft: "1rem" }}>
            <Typography
              fontWeight="bold"
              variant="h6"
              style={{ textTransform: "uppercase", color: "#fff" }}
            >
              Production Priority
            </Typography>
          </div>
          <div style={{ margin: "0 1rem" }}>
            <Button
              variant="contained"
              onClick={timeTab.save}
              disabled={timeTab.saving}
              sx={{
                minWidth: "12em",
                backgroundColor: timeTab.saving ? "grey" : "var(--buttonYellow)",
                "&:hover": {
                  backgroundColor: timeTab.saving ? "grey" : "var(--buttonYellowHover)",
                },
              }}
            >
              {timeTab.saving ? "Saving..." : "Save Settings"}
            </Button>
          </div>
        </div>
      </Grid>
      <Grid item xs={12}>
        <TimeTabView
          data={timeTab.data}
          columns={timeTab.columns}
          updateData={timeTab.updateData}
        />
      </Grid>
    </Grid>
  );
};

export default ProductionPriorityUI;
